<ng-container
  provideElements
  [documentId]="documentId"
  [reportIndex]="reportIndex"
  [funds]="funds">

  <wct-element-host [element]="'Header' | element | async" />

  <div class="map">
    @if (('mBMK' | element | async) || ('ohne BMK' | element | async)) {
      <div
        class="highcharts-light mapchart chart-disable-legend-pointer-events"
        highcharts-chart
        (chartInstance)="chart = $event"
        [options]="(('mBMK' | element | async) || ('ohne BMK' | element | async))?.renderable | tableToCountryData | countryChartOptions"
        [Highcharts]="Highmaps"
        [constructorType]="'mapChart'"></div>

      <div class="zoom">

        <sd-4-5-1-icon
          (click)="zoomOut($event)"
          color="primary"
          library="{{ iconLibrary }}"
          name="system/minus-circle"></sd-4-5-1-icon>

        <sd-4-5-1-icon
          (click)="zoomIn($event)"
          color="primary"
          library="{{ iconLibrary }}"
          name="system/plus-circle"></sd-4-5-1-icon>

      </div>
    } @else {
      <sd-4-5-1-spinner class="wct-absolute-center"></sd-4-5-1-spinner>
    }
  </div>

  <wct-element-host [element]="'Fussnote' | element | async" />
</ng-container>
